/* ============================================================
   科技報你知（部落格）互動：精選輪播（列表）＋複製文章連結（內頁）
   移植自 dan_workspace/blog-website 的 blog-list.js／blog-article.js；標記改由 Liquid 伺服器端輸出，
   這裡只綁行為。對應 sections/spidercard-blog.liquid、sections/spidercard-article.liquid。
   - defer 載入、兩種頁面共用：找不到對應元素就略過，不丟錯。
   - 文案（暫停／播放、已複製／複製失敗）由標記上的 data-label-* 帶入（Liquid 的 | t），這裡不寫死。
   - 輪播：滑鼠移入、鍵盤聚焦、分頁隱藏、捲出畫面、使用者暫停、系統減少動態時都不自動輪播。
   ============================================================ */
(function () {
  'use strict';

  var ROTATE_MS = 6000;
  var COPIED_MS = 2500;
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /**
   * 綁定一個精選輪播（[data-bl-hero]）。所有 slide、圖片、圓點已由 Liquid 輸出，第一張為 is-active。
   *
   * @param {HTMLElement} hero - 輪播的根元素。
   * @returns {void}
   */
  function initHero(hero) {
    var images = hero.querySelectorAll('.bl-hero-img');
    var slides = hero.querySelectorAll('.bl-slide');
    var dots = hero.querySelectorAll('.bl-dot');
    var copy = hero.querySelector('[data-bl-copy]');
    var toggle = hero.querySelector('[data-bl-toggle]');
    var media = hero.querySelector('[data-bl-media]');
    var count = slides.length;
    if (count < 2) return;

    var state = {
      index: 0,
      timer: null,
      userPaused: false,
      hovered: false,
      focused: false,
      pageHidden: document.hidden,
      inView: true
    };

    /**
     * 現在能不能自動輪播；任何一個暫停條件成立都不輪播。
     *
     * @returns {boolean} 可輪播回傳 true。
     */
    function canRotate() {
      return !state.userPaused && !state.hovered && !state.focused &&
        !state.pageHidden && state.inView && !reduceMotion.matches;
    }

    /**
     * 停掉計時器與進度動畫。
     *
     * @returns {void}
     */
    function stopTimer() {
      if (state.timer) { clearTimeout(state.timer); state.timer = null; }
      hero.classList.remove('is-running');
    }

    /**
     * 依目前狀態決定要不要（重新）啟動計時器；每次都從完整的 ROTATE_MS 起算，進度動畫一併重播。
     *
     * @returns {void}
     */
    function syncTimer() {
      stopTimer();
      hero.style.setProperty('--bl-rotate', ROTATE_MS + 'ms');
      hero.classList.toggle('is-paused', !canRotate());
      if (!canRotate()) return;
      // 讀一次 offsetWidth 強制重排，讓 CSS 動畫從頭播放
      void hero.offsetWidth;
      hero.classList.add('is-running');
      state.timer = setTimeout(function () { go(state.index + 1, false); }, ROTATE_MS);
    }

    /**
     * 切到指定項目（超出範圍會循環）。
     *
     * @param {number} next - 目標索引。
     * @param {boolean} byUser - 是否由使用者操作；是的話讓螢幕閱讀器播報新內容。
     * @returns {void}
     */
    function go(next, byUser) {
      var target = ((next % count) + count) % count;
      state.index = target;
      for (var i = 0; i < count; i += 1) {
        var on = i === target;
        if (images[i]) images[i].classList.toggle('is-active', on);
        slides[i].classList.toggle('is-active', on);
        if (on) { slides[i].removeAttribute('aria-hidden'); slides[i].removeAttribute('inert'); }
        else { slides[i].setAttribute('aria-hidden', 'true'); slides[i].setAttribute('inert', ''); }
        if (dots[i]) {
          dots[i].classList.toggle('is-active', on);
          dots[i].setAttribute('aria-current', on ? 'true' : 'false');
        }
      }
      // 自動輪播時不播報（避免一直打斷）；使用者操作或已暫停時才唸出新內容
      if (copy) copy.setAttribute('aria-live', (byUser || state.userPaused) ? 'polite' : 'off');
      syncTimer();
    }

    /**
     * 更新暫停／播放鈕的圖示與 aria-label。
     * 只切 class 與屬性，不用 innerHTML 換圖示：滑鼠停在按鈕上時被移除的節點不會送 pointerleave，輪播會卡在暫停。
     *
     * @returns {void}
     */
    function renderToggle() {
      hero.classList.toggle('is-user-paused', state.userPaused);
      if (!toggle) return;
      var label = toggle.getAttribute(state.userPaused ? 'data-label-play' : 'data-label-pause');
      if (label) toggle.setAttribute('aria-label', label);
    }

    hero.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button || !hero.contains(button)) return;
      if (button.hasAttribute('data-bl-prev')) go(state.index - 1, true);
      else if (button.hasAttribute('data-bl-next')) go(state.index + 1, true);
      else if (button.hasAttribute('data-bl-toggle')) {
        state.userPaused = !state.userPaused;
        renderToggle();
        syncTimer();
      } else if (button.hasAttribute('data-bl-dot')) go(parseInt(button.getAttribute('data-bl-dot'), 10) || 0, true);
    });

    // 只有滑鼠才算「滑過」；觸控點一下沒有對應的離開事件，會讓輪播卡在暫停
    hero.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'mouse') { state.hovered = true; syncTimer(); }
    });
    hero.addEventListener('pointerleave', function (event) {
      if (event.pointerType === 'mouse') { state.hovered = false; syncTimer(); }
    });
    hero.addEventListener('focusin', function () { state.focused = true; syncTimer(); });
    hero.addEventListener('focusout', function (event) {
      if (!hero.contains(event.relatedTarget)) { state.focused = false; syncTimer(); }
    });
    hero.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') go(state.index - 1, true);
      else if (event.key === 'ArrowRight') go(state.index + 1, true);
    });

    // 手機滑動：水平位移夠大且大於垂直位移才換頁，不干擾上下捲動
    if (media) {
      var startX = 0;
      var startY = 0;
      var tracking = false;
      media.addEventListener('pointerdown', function (event) {
        tracking = true; startX = event.clientX; startY = event.clientY;
      });
      media.addEventListener('pointerup', function (event) {
        if (!tracking) return;
        tracking = false;
        var dx = event.clientX - startX;
        var dy = event.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(state.index + (dx < 0 ? 1 : -1), true);
      });
      media.addEventListener('pointercancel', function () { tracking = false; });
    }

    // 捲出畫面就暫停，回來再繼續
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        state.inView = entries[0].isIntersecting;
        syncTimer();
      }, { threshold: 0.2 }).observe(hero);
    }

    document.addEventListener('visibilitychange', function () { state.pageHidden = document.hidden; syncTimer(); });
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', syncTimer);

    renderToggle();
    syncTimer();
  }

  /**
   * 把文字放進剪貼簿。優先用 Clipboard API，不支援或被拒絕時退回 execCommand。
   *
   * @param {string} text - 要複製的文字。
   * @returns {Promise<void>} 成功時 resolve，失敗時 reject。
   */
  function copyText(text) {
    /**
     * 用隱藏的 textarea＋execCommand 複製（舊瀏覽器、非 https 環境）。
     *
     * @returns {Promise<void>} 成功時 resolve，失敗時 reject。
     */
    function fallback() {
      return new Promise(function (resolve, reject) {
        var box = document.createElement('textarea');
        box.value = text;
        box.setAttribute('readonly', '');
        box.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
        document.body.appendChild(box);
        box.select();
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (_) { ok = false; }
        document.body.removeChild(box);
        if (ok) resolve(); else reject(new Error('copy failed'));
      });
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(fallback);
    }
    return fallback();
  }

  /**
   * 綁定「複製文章連結」按鈕（[data-bl-copylink]），結果寫進同一列的 [data-bl-copied]（role="status"）。
   *
   * @param {HTMLButtonElement} button - 複製按鈕；網址在 data-url。
   * @returns {void}
   */
  function initCopyLink(button) {
    var scope = button.closest('.bl-art-foot') || button.parentNode;
    var status = scope ? scope.querySelector('[data-bl-copied]') : null;
    var timer = null;

    /**
     * 顯示結果訊息，幾秒後清掉。
     *
     * @param {string} message - 要顯示的文字。
     * @returns {void}
     */
    function announce(message) {
      if (!status || !message) return;
      status.textContent = message;
      clearTimeout(timer);
      timer = setTimeout(function () { status.textContent = ''; }, COPIED_MS);
    }

    button.addEventListener('click', function () {
      var url = button.getAttribute('data-url') || window.location.href.split('#')[0];
      copyText(url).then(
        function () { announce(button.getAttribute('data-label-copied')); },
        function () { announce(button.getAttribute('data-label-failed')); }
      );
    });
  }

  /**
   * 進入點：每個部落格區塊各自綁定，區塊不存在時不做事。
   *
   * @returns {void}
   */
  function init() {
    var pages = document.querySelectorAll('.sc-blog-page');
    for (var i = 0; i < pages.length; i += 1) {
      var heroes = pages[i].querySelectorAll('[data-bl-hero]');
      for (var h = 0; h < heroes.length; h += 1) initHero(heroes[h]);
      var buttons = pages[i].querySelectorAll('[data-bl-copylink]');
      for (var b = 0; b < buttons.length; b += 1) initCopyLink(buttons[b]);
    }
  }

  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  } catch (error) {
    console.error('[spidercard-blog]', error);
  }
})();
